import 'bootstrap/dist/css/bootstrap.css';
import * as React from 'react';
import ReactDOM from "react-dom/client"
import { Provider } from 'react-redux';
import { PersistGate } from 'redux-persist/lib/integration/react';
import { ReactReduxFirebaseProvider } from 'react-redux-firebase';
import { Router } from 'react-router-dom';
import App from './App';
import registerServiceWorker from './registerServiceWorker';
import firebase from './firebase/firebase';
import { persistor, store, history } from './store/configureStore';
import LoadingScreen from './components/LoadingScreens/LoadingScreen';

const rrfConfig = {
    userProfile: 'users',
} // react-redux-firebase config

const rrfProps = {
    firebase,
    config: rrfConfig,
    dispatch: store.dispatch,
    history: history,
}

const root = ReactDOM.createRoot(document.getElementById("root") as HTMLElement);
root.render(
    <Provider store={store}>
        <PersistGate loading={<LoadingScreen />} persistor={persistor} />
        <ReactReduxFirebaseProvider {...rrfProps}>
            <Router history={history}>
                <App />
            </Router>
        </ReactReduxFirebaseProvider >
    </Provider>
);

registerServiceWorker();